import React from 'react';
import Image from 'next/image';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SectionHeading from 'components/SectionHeading';

export default function PartnersSection({ partners = [] }) {
    const { t } = useTranslation();
    const lang = useSelector((s) => s.system.lang || 'mn');

    if (!partners || partners.length === 0) return null;

    return (
        <section className="py-20 lg:py-24 bg-brand-cream">
            <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
                <SectionHeading
                    eyebrow={lang === 'en' ? 'Partners' : 'Хамтрагч'}
                    title={
                        lang === 'en'
                            ? 'World-Leading Partners'
                            : 'Төслийн оролцогч байгууллагууд'
                    }
                />

                {/* Logo grid */}
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-brand-cream-dark">
                    {partners.map((partner) => {
                        const name = lang === 'en' && partner.nameEn ? partner.nameEn : partner.name;
                        const logoUrl = partner.logoUrl || '/placeholders/partner-default.svg';

                        const inner = (
                            <div className="flex items-center justify-center h-32 px-6 bg-white hover:bg-brand-yellow transition-all group">
                                <div className="relative w-full h-full">
                                    <Image
                                        src={logoUrl}
                                        alt={name}
                                        fill
                                        sizes="(max-width: 768px) 50vw, 16vw"
                                        className="object-contain transition-all"
                                    />
                                </div>
                            </div>
                        );

                        return partner.websiteUrl ? (
                            <a
                                key={partner.id}
                                href={partner.websiteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={name}
                            >
                                {inner}
                            </a>
                        ) : (
                            <div key={partner.id} aria-label={name}>
                                {inner}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}